<script>
export default {

    props: {
        customer:{
            type:Object,
            default: null 
        },

      },

}
</script>

<template>
    <div v-if="customer" >
        <div class="row mb-4 mt-2 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class=" font-size-16 text-dark "><i class="fas fa-user-tie font-size-16 mr-2"/>{{$t('subscription.detailsModal.name')}} </div>
            <div class="font-size-16 mt-1 font-weight-bold text-primary">{{customer.name == null ? "-" : customer.name}}</div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class=" font-size-16 text-dark  "><i class="fas fa-phone font-size-16 mr-2"/>{{$t('subscription.detailsModal.phone')}}</div>
            <div class="font-size-16 mt-1 font-weight-bold text-primary">{{customer.phone == null ? "-" : customer.phone}}</div>
            </div>
        </div>

        <div class="row mt-4 mb-4 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <span class=" font-size-16 text-dark   "><i class="fa fa-industry font-size-16 mr-2"/>{{$t('subscription.detailsModal.companyName')}}</span>  
            <br/><span class="font-size-16 mt-1 font-weight-bold text-primary">{{customer.companyName == null ? "-" :  customer.companyName}}</span>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <span class=" font-size-16 text-dark "><i class="fas fa-envelope font-size-16 mr-2"/>{{$t('subscription.detailsModal.mail')}}</span>
            <br/><span class="font-size-16  mt-1 font-weight-bold text-primary">{{customer.mail== null ? "-" :customer.mail }}</span>
            </div>
        </div>

        <div class="row mt-4 mb-2 ml-4">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <span class=" font-size-16 text-dark "><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.address')}}</span>
            <br/>
            <span class="font-size-16 mt-1 font-weight-bold text-primary">{{customer.address == null ? "-" : customer.address }}</span>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <span class=" font-size-16 text-dark  "><i class="fas fa-flag font-size-16 mr-2"/>{{$t('subscription.detailsModal.country')}}</span>
            <br/><span class="font-size-16 mt-1 font-weight-bold text-primary">{{customer.country == null ? "-" : customer.country.name == null ? "-" : customer.country.name }}</span>
            </div>
        </div>

        <div class="row mt-4 mb-2 ml-4">

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <span class=" font-size-16 text-dark font-weight-bold"><i class="fas fa-city font-size-16 mr-2"/>{{$t('subscription.detailsModal.city')}}</span>
            <br/><span class="font-size-16 font-weight-bold text-primary">{{customer.city.name == null ? "-" : customer.city.name == null ? "-" : customer.city.name }}</span>
            </div>

        </div>
    </div>
</template>